import { useTranslation } from 'react-i18next';

export default function Footer() {
  const { t } = useTranslation();

  return (
    <footer className="bg-background-100 border-t border-background-200/70">
      <div className="px-4 md:px-6 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-10">
          <div>
            <h3 className="font-heading font-bold text-lg text-foreground-900 mb-4">CSSBuy Spreadsheet</h3>
            <p className="text-sm text-foreground-600 leading-relaxed">
              {t('disclaimer')}
            </p>
          </div>

          <div>
            <h4 className="font-semibold text-sm text-foreground-800 mb-4 uppercase tracking-wide">{t('footer.resources')}</h4>
            <ul className="space-y-2">
              <li>
                <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-sm text-foreground-600 hover:text-foreground-900 cursor-pointer">{t('footer.resources')}</a>
              </li>
              <li>
                <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-sm text-foreground-600 hover:text-foreground-900 cursor-pointer">{t('nav.guides')}</a>
              </li>
              <li>
                <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-sm text-foreground-600 hover:text-foreground-900 cursor-pointer">{t('nav.review')}</a>
              </li>
              <li>
                <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-sm text-foreground-600 hover:text-foreground-900 cursor-pointer">{t('nav.shipping')}</a>
              </li>
              <li>
                <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-sm text-foreground-600 hover:text-foreground-900 cursor-pointer">{t('nav.qc')}</a>
              </li>
              <li>
                <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-sm text-foreground-600 hover:text-foreground-900 cursor-pointer">{t('nav.comparisons')}</a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-semibold text-sm text-foreground-800 mb-4 uppercase tracking-wide">{t('footer.company')}</h4>
            <ul className="space-y-2">
              <li>
                <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-sm text-foreground-600 hover:text-foreground-900 cursor-pointer">{t('footer.about')}</a>
              </li>
              <li>
                <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-sm text-foreground-600 hover:text-foreground-900 cursor-pointer">{t('footer.editorial')}</a>
              </li>
              <li>
                <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-sm text-foreground-600 hover:text-foreground-900 cursor-pointer">{t('footer.updates')}</a>
              </li>
              <li>
                <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-sm text-foreground-600 hover:text-foreground-900 cursor-pointer">{t('footer.contact')}</a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-semibold text-sm text-foreground-800 mb-4 uppercase tracking-wide">{t('footer.safety')}</h4>
            <ul className="space-y-2">
              <li>
                <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-sm text-foreground-600 hover:text-foreground-900 cursor-pointer">{t('footer.safety')}</a>
              </li>
              <li>
                <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-sm text-foreground-600 hover:text-foreground-900 cursor-pointer">{t('footer.privacy')}</a>
              </li>
              <li>
                <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-sm text-foreground-600 hover:text-foreground-900 cursor-pointer">{t('footer.terms')}</a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-background-200/70 pt-6">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            <p className="text-xs text-foreground-500 text-center md:text-left">
              {t('footer.disclaimer')}
            </p>
            <p className="text-xs text-foreground-500">
              &copy; 2026 CSSBuy Spreadsheet. All rights reserved.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}